import { FuelType } from "../../../models/vehicle/fuelType";
import { FuelEmission } from "../../../store/reportOptionsSlice";

// Avg consumption calculation
export function calculateAvgConsumption(distance: number, fuel: number) {
    return distance === 0 ? null : (fuel / distance) * 100;
}

// Emission calculation from distance
export function calculateEmissionsFromDistanceToCo2Kg(distance: number, fuelType: FuelType, fuelEmissions: FuelEmission[]) {
    const emission = fuelEmissions.find(x => x.fuelType.toString() === FuelType[fuelType]);
    const emissionRating = emission?.emissionFactor ?? -1;

    return emissionRating * distance / 1000;
}

